import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', (event) => {
      const confirmation = window.confirm(this.element.dataset.message);
      if (!confirmation) {
        event.preventDefault();
      }
    });
  }
}
